import React from 'react'
import { object, array } from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './PlansPage.styl'
import { connect } from 'react-redux'
import { withContext } from '../../../utils/withContext'

class PlansPage extends React.Component {

	static fetchQueries = [
		'services?tag=challenges',
		'athletes/profile'
	]

	static propTypes = {
		serviceFetch: array,
		athlete: object,
		context: object
	}

	computeServices(services, isSubscrived, createLocaleLink) {
		return (services || []).map((ele, index) => {
			if (!(ele || {}).card) {
				return null
			}
			const { card: { title, summary }, images } = ele
			const backgroundImage = images && Array.isArray(images) && images.length ? `url(${ images[0] })` : null
			return (
				<Link
					key={ index }
					to={ createLocaleLink(`/${ isSubscrived ? 'challenges' : 'apt/plan' }/${ ele.id }`) }
					className={ styles['plan-container'] }
					style={ { backgroundImage } }
				>
					<h3>{ title }</h3>
					<p>{ summary }</p>
					<div className={ styles['overlay'] } />
				</Link>
			)
		})
	}

	render() {
		const { serviceFetch, athlete, context: { i18n, createLocaleLink } } = this.props
		const isSubscrived = ((athlete || {}).subscriptions || []).find(v => v.isActive)
		const computedServices = this.computeServices(serviceFetch, isSubscrived, createLocaleLink)
		return (
			<div className={ styles['grid'] }>
				<div className={ styles['content'] }>
					<h1>{ i18n`post_registration_plan_label` }</h1>
					<div className={ styles['plans-container'] }>
						{ computedServices }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	serviceFetch: state.fetch.results[PlansPage.fetchQueries[0]],
	athlete: state.fetch.results[PlansPage.fetchQueries[1]]
})

export default withContext(connect(mapStateToProps)(PlansPage))



// WEBPACK FOOTER //
// ./src/client/webapp/pages/PlansPage/PlansPage.js